import {AxiosServer, ArrRemoveSubItem} from '../../utils';

let namespace = 'antdCompTest_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。
const SET = (value) =>(dispatch,getState)=>{
	
	dispatch({type: namespace+'forcedUpdate', payload: value})
}



const GET =(value)=>(dispatch,getState)=>{

	let Axios = AxiosServer();
	let store =getState().antdCompTestReducer;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}		

	return Axios.post('/parameters/all',value).then((res)=>{	
		dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, dataLoading: false}});  // 翻页的时候，先更新 dataLoading: true
		return '成功'
	}).catch((err)=>{
		console.log('err:',err);
		return '失败'
	});	
	
}

const GETARGS =(value)=>(dispatch,getState)=>{

	let Axios = AxiosServer();	
	return Axios.post('/parameters/all',value).then((res)=>{	
		// dispatch({type: namespace+'forcedUpdate', payload: {argsData:res.data.data}});  // 查询接口，不用刷新整页
		return '成功'
	}).catch((err)=>{
		console.log('err:',err);
		return '失败'
	});	
	
}

const CREATE =(value)=>(dispatch,getState)=>{

	//value 是传过来的参数
	//getState 可获取当前store的状态
	
	let Axios = AxiosServer();
	
	return  Axios.post('/parameters/create',value).then((res)=>{
		console.log(res.data)			
	   
	   if (res.data.status===true){
		   dispatch({type:namespace+'addOneRowData',payload:{data: res.data.data}});	
		   return '添加成功'
	   }else{
		   return '添加失败'
	   }	   
	   
	}).catch((err)=>{
		console.log('err:',err);
	});	
	
}

const UPDATE =(value, selectedRowIndex = null)=>(dispatch,getState)=>{
	//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
	//dispatch({type:'login/set',payload:{loading:true}});
	//value 是传过来的参数
	//getState 可获取当前store的状态
	//强转id为数字，规免出错
	
	let Axios = AxiosServer();
	
	return  Axios.post('/parameters/update',value).then((res)=>{	
		
		dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});		
	//   dispatch(userlist_GET({order:[['id']]}));
	   return '更新成功'
	}).catch((err)=>{
		//dispatch({type:'login/set',payload:{loading:false}});
		console.log('err:',err);
	});	
	
}

const  DELETE = (value, selectedRowIndex = null)=> (dispatch,getState)=>{	 	
  	//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态		
	//dispatch({type:'login/set',payload:{loading:true}}); //让程序显示加载状态，后面false为取消

	//delete流程，先从store中删除该条记录，然后异步到服务器删除。如果服务器删除失败，再从服务器获取新数据。通知删除失败	

	const store =getState();	
	// let data =store.userlistReducer.data;	
	
    // let OldData =[...data];	
	// data=ArrRemoveSubItem(data,value);	//将删除记录从store中删除
	let Axios = AxiosServer();	
	return  Axios.post('/parameters/destroy',value).then((res)=>{			
		//dispatch({type:'login/set',payload:{loading:false}});	
		if (res.data.status == false){	
			//dispatch(userlist_SET_del(OldData)); //将删除记录从store中恢复
			return '删除失败'
		}
		dispatch({type:namespace+'deleteDataById', payload: {id: value.id, selectedRowIndex}});
		
		return '删除成功'
	}).catch(err=>{		
		console.log('err:',err);
		
	});		
	
	
}


const  RESTORE = (value, selectedRowIndex = null)=> (dispatch,getState)=>{	 	
  	//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态		
	//dispatch({type:'login/set',payload:{loading:true}}); //让程序显示加载状态，后面false为取消

	//delete流程，先从store中删除该条记录，然后异步到服务器删除。如果服务器删除失败，再从服务器获取新数据。通知删除失败	

	const store =getState();	
	// let data =store.userlistReducer.data;	
	
    // let OldData =[...data];	
	// data=ArrRemoveSubItem(data,value);	//将删除记录从store中删除
	let Axios = AxiosServer();	
	return  Axios.post('/parameters/restore',value).then((res)=>{	
		
		//dispatch({type:'login/set',payload:{loading:false}});	
		if (res.data.status == false){	
			//dispatch(userlist_SET_del(OldData)); //将删除记录从store中恢复
			return '恢复失败'
		}
		dispatch({type:namespace+'addOneRowData',payload:{data: res.data.data}});	
		
		return '恢复成功'
	}).catch(err=>{		
		console.log('err:',err);
		
	});		
	
	
}


export {SET, GET, DELETE,CREATE,UPDATE , RESTORE,GETARGS};